/**
 * @Description 商圈详情-基本信息栏-横向展示-单个特殊字段
 */

import { FC } from 'react';
import styles from './index.module.less';
// import cs from 'classnames';

const BlockHorizontal: FC<any> = ({
  data,
  iconSrc = ''
}) => {
  return (
    <div className={styles.blockHorizontal}>
      <div className={styles.name}>{data.title}</div>
      <div className={styles.listItem}>
        <div className='fs-14 c-222 bold'>{data?.value || '-'}</div>
        {data?.value && data?.unit ? <div className='fs-12 c-222'>{data?.unit}</div> : <></>}
        {(data?.basicValue && data?.tag) ? <div className={styles.tag}>{data.tag.replace('内', '')}</div> : <></>}
        {iconSrc ? <div className={styles.imgWrapper}>
          <img src={iconSrc}/>
        </div> : <></>}
      </div>
    </div>
  );
};

export default BlockHorizontal;
